import {OwnerId, OwnerPayload, ResolveOwner, ProductType} from "platformed-client/types";
import {unreachableCase} from "../utils/typescript";
import {platformedClient} from ".";

function toResolveRequest(owner: OwnerPayload): ResolveOwner {
  switch (owner.type) {
    case "User":
      return {type: "User", content: owner.content.user_id};
    case "Team":
      return {type: "Team", content: owner.content.team_id};
    default:
      unreachableCase(owner);
  }
}

/** Exchange picked user/team payloads for the `Owner`s the review APIs take. */
export async function resolveToOwners(owners: OwnerPayload[]) {
  if (owners.length === 0) return [];
  return await resolve(owners.map(toResolveRequest));
}

export async function resolve(resolveOwners: ResolveOwner[]) {
  return await platformedClient.internalRequest("post", "/region/{region}/api/owners/resolve", {
    path: {},
    body: resolveOwners,
  });
}

export async function get(ownerId: OwnerId) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/owners/{owner_id}", {
    path: {owner_id: ownerId},
  });
}

export async function load(ownerIds: OwnerId[]) {
  return await platformedClient.internalRequest("post", "/region/{region}/api/owners/load", {body: ownerIds});
}

export async function list(product: ProductType) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/owners", {query: {product}});
}
